import Vue from 'vue'
import Router from 'vue-router'

import auth from '@/libs/auth'
import socket from '@/libs/socket'
import userAgent from '@/libs/user-agent'

// pages
const AcceptInvite = () => import(/* webpackChunkName: "PageAcceptTeamInvite" */ '@/components/Pages/AcceptTeamInvite')
const Auditorium = () => import(/* webpackChunkName: "PageAuditorium" */ '@/components/Pages/Auditorium')
const AppRedirect = () => import(/* webpackChunkName: "PageAppRedirect" */ '@/components/Pages/AppRedirect')
const Contact = () => import(/* webpackChunkName: "PageContact" */ '@/components/Pages/Contact')
const Legal = () => import(/* webpackChunkName: "PageLegal" */ '@/components/Pages/Legal')
const Login = () => import(/* webpackChunkName: "ModalLogin" */ '@/components/Modals/Login')
const PhoneLogin = () => import(/* webpackChunkName: "PhoneLogin" */ '@/components/Forms/PhoneLogin')
const ResetPassword = () => import(/* webpackChunkName: "PageResetPassword" */ '@/components/Pages/ResetPassword')
const Search = () => import(/* webpackChunkName: "PageSearchResults" */ '@/components/Pages/SearchResults')
const ArticleRedirect = () => import(/* webpackChunkName: "ArticleRedirect" */ '@/components/Pages/ArticleRedirect')
const LeaderBoard = () => import(/* webpackChunkName: "PageLeaderBoard" */ '@/components/Pages/LeaderBoard')
const ProjectLeaderBoard = () => import(/* webpackChunkName: "PageLeaderBoard" */ '@/components/Pages/ProjectLeaderBoard')
const FAQ = () => import(/* webpackChunkName: "FAQ" */ '@/components/Pages/FAQ')
const Maintenance = () => import(/* webpackChunkName: "PageMaintenance" */ '@/components/Pages/Maintenance')
const ViewAll = () => import(/* webpackChunkName: "PageViewAll" */ '@/components/Pages/ViewAll')
const YearlyPage = () => import(/* webpackChunkName: "PageYearlyPage" */ '@/components/Pages/YearlyPage')
const Resources = () => import(/* webpackChunkName: "PageResources" */ '@/components/Pages/Resources')
const PublicExhibition = () => import(/* webpackChunkName: "PageResources" */ '@/components/Pages/Resources')
const StoryFeed = () => import(/* webpackChunkName: "PageStoryFeed" */ '@/components/Pages/StoryFeed')
const Cookies = () => import(/* webpackChunkName: "PageCookies" */ '@/components/Pages/Cookies')
const YSC = () => import(/* webpackChunkName: "PageYSC" */ '@/components/Pages/LandingPage/YSC')
const YSC2020 = () => import(/* webpackChunkName: "PageYSC" */ '@/components/Pages/LandingPage/YSC2020')
const AJAS = () => import(/* webpackChunkName: "PageAJAS" */ '@/components/Pages/LandingPage/AJAS')
const VirtualLobby = () => import(/* webpackChunkName: "VirtualLobby" */ '@/components/Pages/Lobby')
const ISEF2022 = () => import(/* webpackChunkName: "PageISEF2022" */ '@/components/Pages/LandingPage/ISEF2022')
const BroadcomMasters = () => import(/* webpackChunkName: "BroadcomMasters" */ '@/components/Pages/LandingPage/Broadcom')
const STS = () => import(/* webpackChunkName: "PageSTS" */ '@/components/Pages/LandingPage/STS')
const GasLobby = () => import(/* webpackChunkName: "GasLobby" */ '@/components/Pages/Lobby').then(({ Lobby }) => Lobby(process.env.APP_NAME))
const BuckeyeLobby = () => import(/* webpackChunkName: "BuckeyeLobby" */ '@/components/Pages/LandingPage/BuckeyeLobby')
const OasamLobby = () => import(/* webpackChunkName: "OasamLobby" */ '@/components/Pages/LandingPage/OasamLobby')
const ProjectBoard = () => import(/* webpackChunkName: "PageProjectBoard" */ '@/components/Pages/LandingPage/ProjectBoard')
const FablabsThankYou = () => import(/* webpackChunkName: "PageFablabsThankYou" */ '@/components/Pages/FablabsThankYou')
const UpdateFeed = () => import(/* webpackChunkName: "PageUpdateFeed" */ '@/components/Pages/UpdateFeed')
const Regions = () => import(/* webpackChunkName: "PageRegions" */ '@/components/Pages/Regions')
const PressRoom = () => import(/* webpackChunkName: "PressRoom" */ '@/components/Pages/PressRoom')
const YscExpoBooth2022 = () => import(/* webpackChunkName: "YscExpoBooth2022" */ '@/components/Pages/YscExpoBooth2022')
const IsefStore = () => import(/* webpackChunkName: "IsefStore" */ '@/components/Pages/IsefStore')
const SocietyOffice2022 = () => import(/* webpackChunkName: "SocietyOffice2022" */ '@/components/Pages/SocietyOffice2022')
// const SocietyOffice2021 = () => import(/* webpackChunkName: "SocietyOffice2021" */ '@/components/Pages/SocietyOffice2021')
const IsefFinalistBooth = () => import(/* webpackChunkName: "IsefFinalistBooth" */ '@/components/Pages/IsefFinalistBooth')
const IsefHub = () => import(/* webpackChunkName: "IsefHub" */ '@/components/Pages/IsefHub')
const RegeneronBooth = () => import(/* webpackChunkName: "RegeneronBooth" */ '@/components/Pages/RegeneronBooth')
// const IsefCollegeBooth = () => import(/* webpackChunkName: "IsefCollegeBooth" */ '@/components/Pages/IsefCollegeBooth')
// const FinalistExhibitHall2021 = () => import(/* webpackChunkName: "FinalistExhibitHall" */ '@/components/Pages/FinalistExhibitHall2021')
const IsefCollegeBooth2022 = () => import(/* webpackChunkName: "IsefCollegeBooth2022" */ '@/components/Pages/IsefCollegeBooth2022')
const FinalistExhibitHall = () => import(/* webpackChunkName: "FinalistExhibitHall" */ '@/components/Pages/FinalistExhibitHall')
const SocietyFinalistBooth = () => import(/* webpackChunkName: "SocietyFinalistBooth" */ '@/components/Pages/SocietyFinalistBooth')
const StsFinalistBooth = () => import(/* webpackChunkName: "StsFinalistBooth" */ '@/components/Pages/StsFinalistBooth')
const BroadcomFoundationBooth = () => import(/* webpackChunkName: "BroadcomFoundationBooth" */ '@/components/Pages/BroadcomFoundationBooth')
const AdminJudge = () => import(/* webpackChunkName: "AdminJudge" */ '@/components/Pages/AdminJudge')
const CnmiiwsfLobby = () => import(/* webpackChunkName: "CnmiiwsfLobby" */ '@/components/Pages/Lobby').then(({ Lobby }) => Lobby(process.env.APP_NAME))
const StsFinalistResources = () => import(/* webpackChunkName: "StsFinalistResources" */ '@/components/Pages/StsFinalistResources')
const Ysc2022ActivitiesAndResources = () => import(/* webpackChunkName: "Ysc2022ActivitiesAndResources" */ '@/components/Pages/Ysc2022ActivitiesAndResources')
// iframe pages
const Embed = () => import(/* webpackChunkName: "PageEmbed" */ '@/components/Pages/IframeUrl')
const WixUrl = () => import(/* webpackChunkName: "WixUrl" */ '@/components/Pages/IframeUrl')
const GirlsAndSteam = () => import(/* webpackChunkName: "GirlsAndSteam" */ '@/components/Pages/IframeUrl')
const OhioSci = () => import(/* webpackChunkName: "OhioSci" */ '@/components/Pages/IframeUrl')

// sections
const Admin = () => import(/* webpackChunkName: "SectionAdmin" */ '@/components/Admin/SectionAdmin')
// re-enable when the banner feature is complete
// const ManageBanners = () => import(/* webpackChunkName: "SectionContest" */ '@/components/Admin/SectionAdmin/Banners/ManageRegionBanners')
const ManageIFrames = () => import(/* webpackChunkName: "SectionContest" */ '@/components/Admin/SectionAdmin/Boards/Iframe')
const Home = () => import(/* webpackChunkName: "SectionHome" */ '@/components/Base/SectionHome')
const Messaging = () => import(/* webpackChunkName: "Messaging" */ '@/components/Pages/Messaging')
const Profile = () => import(/* webpackChunkName: "Profile" */ '@/components/Pages/Profile')
const ProjectView = () => import(/* webpackChunkName: "SectionProjectView" */ '@/components/SectionProjectView/Project')
const StoryView = () => import(/* webpackChunkName: "SectionStoryView" */ '@/components/SectionProjectView/Story')
const CreateEdit = () => import(/* webpackChunkName: "SectionCreateEdit" */ '@/components/Base/SectionCreateEdit')
const LobbyCreate = () => import(/* webpackChunkName: "Create" */ '@/components/Admin/SectionAdmin/ClickableAreas/Create')
const LobbyView = () => import(/* webpackChunkName: "View" */ '@/components/Admin/SectionAdmin/ClickableAreas/View')
// misc.
const NotFound = () => import(/* webpackChunkName: "PageNotFound" */ '@/components/Pages/NotFound')
const ProjectBuildTemplate = () => import(/* webpackChunkName: "miscBuildTemplate" */ '@/components/SectionProjectView/BuildTemplate')
const BlankPage = () => import(/* webpackChunkName: "miscBuildTemplate" */ '@/components/Pages/Blank')

// qa
const QAProjectBuildTemplate = () => import(/* webpackChunkName: "qaMiscBuildTemplate" */ '@/components/QATest/QATestBuildTemplate')
const QATest = () => import(/* webpackChunkName: "QATest" */ '@/components/QATest')
const QAProjectView = () => import(/* webpackChunkName: "SectionProjectView" */ '@/components/QATest/QATestProject')

const AuditoriumViewPage = () => import(/* webpackChunkName: "AuditoriumView" */ '@/components/Pages/Auditorium/AuditoriumView')

const CategoryByYear = () => import(/* webpackChunkName: "AuditoriumView" */ '@/components/Pages/CategoryByYear')

Vue.use(Router)

const getRedirect = () => {
  switch (process.env.APP_NAME) {
    // We show the landing page if the APP is one of the below. Thus, redirect is undefined.
    case 'Ysc':
    case 'Ajas':
    case 'Isef':
    case 'Girls-and-steam':
    case 'Projectboard':
    case 'Societyforsciencebcm':
    case 'Ohiosci':
    case 'Cnmiiwsf':
    case 'Sts':
    case 'Buckeye':
    case 'Oasam':
      return undefined
    // We redirect to the home page (showing projects) if APP isn't one of the above
    default:
      return { name: 'home' }
  }
}

const getComponent = () => {
  // Return the respective landing pages. For other partners, we redirect to home, hence the component
  // is undefined.
  switch (process.env.APP_NAME) {
    case 'Ysc':
      return YSC
    case 'Ajas':
      return AJAS
    case 'Isef':
      return ISEF2022
    case 'Projectboard':
      return ProjectBoard
    case 'Girls-and-steam':
      return GirlsAndSteam
    case 'Sts':
      return STS
    case 'Societyforsciencebcm':
      return BroadcomMasters
    case 'Ohiosci':
      return OhioSci
    case 'Cnmiiwsf':
      return CnmiiwsfLobby
    case 'Buckeye':
      return BuckeyeLobby
    case 'Oasam':
      return OasamLobby
    default:
      return undefined
  }
}

const getSocietyFinalistBooth = () => {
  switch (process.env.APP_NAME) {
    case 'Isef':
      return IsefFinalistBooth
    case 'Societyforsciencebcm':
      return SocietyFinalistBooth
    default:
      return StsFinalistBooth
  }
}

const router = new Router({
  base: process.env.BASE,
  mode: userAgent.isApp() ? 'hash' : 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      // This is two routes in one. For some partner sites, we direct the user from / to /home
      // For others, we keep the user on / and show the respective landing page.
      path: '/',
      name: 'landingRedirect',
      meta: { requiresAuth: false },
      redirect: getRedirect(),
      // Since we are redirecting when APP isn't YSC, there is no component to show for that route. Thus,
      // it is undefined. When APP is YSC, we show the YSC (landing page) component instead.
      component: getComponent()
    },
    {
      path: '/:partner?/home',
      name: 'home',
      component: Home,
      meta: { requiresAuth: false },
      beforeEnter: (to, from, next) => {
        switch (process.env.APP_NAME) {
          case 'Girls-and-steam':
          case 'Societyforsciencebcm':
            next({ name: 'landingRedirect' })
            break
          case 'Sts':
            next({ path: '/' })
            break
          default:
            next()
            break
        }
      }
    },
    {
      path: '*/index.html',
      name: 'homeApp',
      component: Home,
      meta: { requiresAuth: false }
    },
    {
      path: '/:partner?/loginPage',
      name: 'login',
      component: Login,
      meta: { engComNoAuth: true },
      beforeEnter: (to, from, next) => {
        if (auth.isLoggedIn() && !to.query.redirect) {
          next({ name: 'home' })
        } else {
          next()
        }
      }
    },
    {
      path: '/:partner?/login/sms/:view?',
      name: 'loginSMS',
      component: PhoneLogin,
      meta: { hideFooter: true, hideMobileNav: true },
      beforeEnter: (to, from, next) => {
        if (auth.isLoggedIn()) {
          next({ name: 'home' })
        } else {
          next()
        }
      }
    },
    {
      path: '/:partner?/logout',
      name: 'logout',
      beforeEnter: (to, from, next) => {
        auth.logout().then(() => {
          const key = (Math.random() + 1).toString(36).substring(7)
          if (process.env.APP_NAME === 'Ysc' || process.env.APP_NAME === 'Isef') {
            next({ name: 'landingRedirect', params: { logout: true } })
          } else {
            next({ name: 'home', query: { r: key }, params: { logout: true } })
          }
        })
      }
    },
    {
      path: '/:partner?/password/reset',
      name: 'resetPassword',
      component: ResetPassword,
      meta: { engComNoAuth: true }
    },
    {
      path: '/:partner?/project/:id',
      name: 'viewProject',
      component: ProjectView,
      meta: { hideFooter: false }
    },
    {
      path: '/qaproject/:id',
      name: 'qaViewProject',
      component: QAProjectView,
      meta: { hideFooter: false, hideNavbar: true, skipStoryAnalytics: true }
    },
    {
      path: '/:partner?/story/:id',
      name: 'viewStory',
      component: StoryView,
      meta: { hideFooter: false }
    },
    {
      path: '/:partner?/story/:id',
      name: 'storyFeed',
      component: StoryFeed,
      meta: { hideFooter: false }
    },
    {
      path: '/:partner?/resource/:id',
      name: 'viewResource',
      component: StoryView,
      meta: { hideFooter: false }
    },
    {
      path: '/:partner?/tag/:tag',
      name: 'projectsTagged',
      component: Home,
      meta: { requiresAuth: false }
    },
    {
      path: '/:partner?/category/:category',
      name: 'projectsCategory',
      component: Home,
      meta: { requiresAuth: false }
    },
    {
      path: '/:partner?/article/:id',
      name: 'articleRedirect',
      component: ArticleRedirect,
      meta: { requiresAuth: false }
    },
    {
      path: '/:partner?/article/-1',
      alias: '/article'
    },
    {
      path: '/:partner?/stem-expo',
      alias: '/stem-expo',
      redirect: { path: '/' }
      // component: ViewAll
      // Uncomment when needed
      // beforeEnter: (to, from, next) => {
      //   if (auth.isLoggedIn()) {
      //     next()
      //   } else {
      //     next({ name: 'home' })
      //   }
      // }
    },
    {
      path: '/:partner?/career-hall',
      name: 'career-hall',
      alias: '/career-hall',
      component: Home
    },
    {
      path: '/:partner?/explore/:explorepage',
      name: 'explore-page',
      alias: '/explore-page',
      component: Home
    },
    {
      path: '/:partner?/discover/:discoverpage',
      name: 'discover',
      alias: '/discover',
      component: ViewAll
    },
    {
      path: '/:partner?/career-hall/:isefsponsortype',
      alias: '/career-hall-sponsor',
      component: ViewAll
    },
    {
      path: '/:partner?/college-hall',
      alias: '/college-hall-alphabetical',
      component: ViewAll
    },
    {
      path: '/:partner?/stem-experiential-hall ',
      name: 'stem-experiential-hall',
      alias: '/stem-experiential-hall',
      component: Home
    },
    {
      path: '/:partner?/stem-experiential-hall/:alphabeticalFilter',
      alias: '/stem-hall-alphabetical',
      component: ViewAll
    },
    {
      path: '/:partner?/create/:id?',
      name: 'create',
      component: CreateEdit,
      meta: { hideFooter: true, requiresAdmin: true },
      alias: '/story/:id/edit'
    },
    {
      path: '/:partner?/contact',
      name: 'contact',
      component: Contact,
      meta: { requiresAuth: false }
    },
    {
      path: '/contact-eng',
      name: 'contact-eng',
      component: Contact,
      meta: { requiresAuth: false }
    },
    {
      path: '/:partner?/legal',
      name: 'legal',
      component: Legal
    },
    {
      path: '/:partner?/FAQ',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/:partner?/leaderboard',
      name: 'leaderboard',
      component: LeaderBoard
    },
    {
      path: '/:partner?/ranking',
      name: 'ranking',
      component: ProjectLeaderBoard
    },
    {
      path: '/:partner?/search-results/:searchQuery',
      name: 'search',
      component: Search,
      meta: { requiresAuth: false }
    },
    {
      path: '/:partner?/profile/:username?/:tab?',
      name: 'profile',
      component: Profile
    },
    {
      path: '/:partner?/inbox/:username?',
      name: 'messaging',
      component: Messaging,
      meta: { hideFooter: true }
    },
    {
      path: '/:partner?/inbox/project/:projectID',
      name: 'projectMessaging',
      component: Messaging,
      meta: { hideFooter: true }
    },
    {
      path: '/:partner?/inbox/public/:topic',
      name: 'publicMessaging',
      component: Messaging,
      meta: { hideFooter: true }
    },
    {
      path: '/:partner?/inbox/group/:topic',
      name: 'groupMessaging',
      component: Messaging,
      meta: { hideFooter: true }
    },
    {
      path: '/:partner?/admin',
      name: 'admin',
      component: Admin,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/:partner?/admin/:section/:name',
      name: 'adminWithPath',
      component: Admin,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/:partner?/admin/clickableAreas/create',
      name: 'lobbyCreate',
      component: LobbyCreate,
      meta: { requiresAuth: true, requiresAdmin: true },
      props: true
    },
    {
      path: '/:partner?/admin/clickableAreas/View',
      name: 'lobbyView',
      component: LobbyView,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    //  re-enable when the banner feature is complete
    // {
    //   path: '/:partner?/contests/banners',
    //   name: 'manageBanners',
    //   component: ManageBanners,
    //   meta: { requiresAuth: true, requiresAdmin: false }
    // },
    {
      path: '/:partner?/contests/iframes',
      name: 'manageIFrames',
      component: ManageIFrames,
      meta: { requiresAuth: true, requiresAdmin: false }
    },
    {
      path: '/:partner?/su/exit',
      name: 'suExit',
      beforeEnter: (to, from, next) => {
        auth.exitSu()
        next(false)
        const base = process.env.BASE
        if (base === undefined || base === '/') {
          window.location = from.path
        } else {
          window.location = `${base.substr(0, base.length - 1)}${from.path}`
        }
      }
    },
    {
      path: '/:partner?/join',
      name: 'acceptInvite',
      component: AcceptInvite
    },
    {
      path: '/:partner?/signup',
      name: 'signUp',
      beforeEnter: (to, from, next) => {
        next({ name: 'home' })
      }
    },
    {
      path: '/:partner?/startButtonTemplate',
      name: 'startButtonTemplate',
      redirect: {
        path: '/:partner?/start/template',
        query: { projectID: 21744, startButton: true, draft: true, private: true }
      },
      meta: { requiresAuth: true, requiresAdmin: false }
    },
    {
      path: '/:partner?/start/impossible-science-challenge',
      redirect: { path: '/:partner?/start', query: { goal: 'impossible-science-challenge' } }
    },
    {
      path: '/:partner?/start/:template',
      name: 'StartWithTemplate',
      component: ProjectBuildTemplate,
      meta: { hideFooter: true, hideMobileNav: true },
      beforeEnter: (to, from, next) => {
        if (auth.isLoggedIn()) {
          next()
        } else {
          next({ name: 'blankPage', query: to.query, params: to.params })
        }
      }
    },
    {
      path: '/:partner?/blankpage',
      name: 'blankPage',
      component: BlankPage
    },
    {
      path: '/impossible-science-project',
      redirect: { name: 'viewProject', param: { id: 1834, partner: 'make' } }
    },
    {
      path: '/youth-science-canada',
      redirect: { name: 'viewProject', param: { id: 1713, partner: 'make' } }
    },
    {
      path: '/liveworx-sbc-overview',
      redirect: { name: 'viewProject', param: { id: 1661, partner: 'make' } }
    },
    {
      path: '/:partner?/redirect',
      name: 'AppRedirect',
      component: AppRedirect,
      meta: { requiresAuth: false, hideFooter: true, hideMobileNav: true }
    },
    {
      path: '/:partner?/maintenance',
      name: 'Maintenance',
      component: Maintenance,
      meta: { requiresAuth: false, hideNavbar: true, hideFooter: true }
    },
    {
      path: '/feed',
      name: 'UpdateFeed',
      component: UpdateFeed,
      beforeEnter: (to, from, next) => {
        if (!auth.isLoggedIn()) {
          next({ name: 'home' })
        } else {
          next()
        }
      }
    },
    {
      path: '/:partner?/about',
      name: 'about',
      component: WixUrl,
      meta: { fixedToolbar: true }
    },
    {
      path: '/:partner?/cwsf-espc',
      name: 'cwsflobby',
      redirect: { path: '/home' }
    },
    {
      path: '/:partner?/viewAll',
      name: 'viewAll',
      component: ViewAll
    },
    {
      path: '/:partner?/adminJudge',
      name: 'adminJudge',
      component: AdminJudge
    },
    {
      path: '/qastart/:template',
      name: 'QAStartWithTemplate',
      component: QAProjectBuildTemplate,
      meta: { hideFooter: true, hideMobileNav: true }
    },
    {
      path: '/qatest',
      name: 'QATest',
      component: QATest,
      meta: { requiresAuth: false, hideNavbar: true }
    },
    {
      path: '/qaStartButtonTemplate',
      redirect: { path: '/qastart/template', query: { projectID: 21744, startButton: true } },
      meta: { requiresAuth: true, requiresAdmin: false }
    },
    {
      path: '/:partner?/auditorium',
      name: 'auditorium',
      component: Auditorium
    },
    {
      path: '/:partner?/cwsf-tv',
      name: 'auditorium',
      component: Auditorium
    },
    {
      path: '/:partner?/auditorium/:auditoriumSlug',
      name: 'auditoriumType',
      component: Resources,
      meta: { requiresAuth: false }
    },
    {
      path: '/:partner?/sciencedayresources',
      name: 'oasResources',
      component: Resources
    },
    {
      path: '/:partner?/resources',
      name: 'resources',
      component: Resources
    },
    {
      path: '/:partner?/resources/:resourceSlug',
      name: 'resourcesType',
      component: Resources,
      meta: { requiresAuth: false }
    },
    {
      path: '/:partner?/resources/:resourceSlug/:resourceSort',
      name: 'resourcesTypeSort',
      component: Resources,
      meta: { requiresAuth: false }
    },
    {
      path: '/:partner?/region/:regionNameParam?/:year?',
      name: 'region',
      component: Regions,
      props: true
    },
    {
      path: '/national/:year',
      name: 'national',
      component: process.env.APP_NAME === 'Ysc' ? YearlyPage : Home
    },
    {
      path: '/:partner?/fablabs-thank-you',
      name: 'fablabsthankyou',
      component: FablabsThankYou
    },
    {
      path: '/:partner?/fablabs-template',
      name: 'fablabstemplate',
      redirect: {
        path: '/:partner?/start/template',
        query: { projectID: 37149, startButton: true, draft: true, private: true }
      }
    },
    {
      path: '/:partner?/:contest?-2021',
      name: 'events',
      component: WixUrl
    },
    {
      path: '/:partner?/best-lassonde',
      name: 'bestLassonde',
      component: WixUrl
    },
    {
      path: '/:partner?/:regionname?-fr',
      name: 'regionsFrench',
      component: WixUrl
    },
    {
      path: '/:partner?/:regionname?-en',
      name: 'regionsEnglish',
      component: WixUrl
    },
    {
      path: '/:partner?/embed',
      name: 'embed',
      component: Embed,
      meta: { requiresAuth: false, hideFooter: true, hideMobileNav: true, hideNavbar: true }
    },
    {
      path: '/:partner?/broadcom-foundation-booth',
      name: 'broadcomfoundationbooth',
      component: BroadcomFoundationBooth
    },
    {
      path: '/:partner?/finalist-booth/:id',
      name: 'iseffinalistbooth',
      component: getSocietyFinalistBooth()
    },
    {
      path: '/:partner?/college-booth/:id',
      name: 'isefcollegebooth2022',
      component: IsefCollegeBooth2022
    },
    {
      path: '/:partner?/career-booth-exhibitor/:id',
      name: 'isefcareerboothexhibitor2022',
      component: IsefCollegeBooth2022
    },
    {
      path: '/:partner?/career-booth-major-sponsor/:id',
      name: 'isefcareerbooth2022',
      component: IsefCollegeBooth2022
    },
    {
      path: '/:partner?/sts-resources',
      name: 'stsFinalistResources',
      component: StsFinalistResources
    },
    {
      path: '/:partner?/activities',
      name: 'Ysc2022ActivitiesAndResources',
      component: Ysc2022ActivitiesAndResources
    },
    {
      path: '/finalists',
      name: 'finalists',
      component: WixUrl
    },
    {
      path: '/makershed',
      redirect: { path: '/profile/makershed' }
    },
    {
      path: '/:partner?/cookies',
      name: 'cookies',
      component: Cookies
    },
    {
      path: '/:partner?/oster-challenge',
      redirect: {
        path: '/:partner?/oster-contest'
      }
    },
    {
      path: '/:partner?/ysc2020',
      name: 'ysc2020',
      component: process.env.APP_NAME !== 'Ysc' ? undefined : YSC2020
    },
    {
      path: '/:partner?/press-room',
      name: 'isefpressroom',
      component: PressRoom
    },
    {
      path: '/:partner?/expobooth/:id',
      name: 'expobooth',
      component: YscExpoBooth2022
    },
    {
      path: '/:partner?/store',
      name: 'isefstore',
      component: IsefStore
    },
    {
      path: '/:partner?/society-office',
      name: 'societyoffice2022',
      component: SocietyOffice2022
    },
    {
      path: '/:partner?/career-booth-regeneron',
      name: 'regeneronbooth',
      component: RegeneronBooth
    },
    {
      path: '/:partner?/hub',
      name: 'isefhub',
      component: IsefHub
    },
    /* {
      path: '/:partner?/finalist-exhibit-hall2021',
      name: 'finalistexhibithall2021',
      component: FinalistExhibitHall2021
    }, */
    {
      path: '/:partner?/finalist-exhibit-hall',
      name: 'finalistexhibithall',
      component: FinalistExhibitHall
    },
    {
      path: '/:partner?/2d/:path',
      name: 'virtuallobby',
      component: VirtualLobby
    },
    {
      path: '/:partner?/notFound',
      name: 'notFound',
      component: NotFound
    },
    {
      path: '/:partner?/partners',
      name: 'partners',
      component: WixUrl
    },
    {
      path: '/:partner?/sponsors',
      name: 'sponsors',
      component: WixUrl
    },
    {
      path: '/:partner?/special-award-organizations',
      name: 'special-award-organizations',
      component: WixUrl
    },
    {
      path: '/:partner?/auditoriumStory/:id',
      name: 'viewAuditoriumStory',
      component: AuditoriumViewPage
    },
    {
      path: '/:partner?/lobby',
      name: 'gasLobby',
      component: process.env.APP_NAME === 'Girls-and-steam' ? GasLobby : NotFound
    },
    {
      path: '/:partner?/scienceday',
      name: 'scienceday',
      component: Home
    },
    {
      path: '/makeprojects-home',
      beforeEnter () { location.href = 'https://www.makeprojects.com' },
      name: 'landingMake'
    },
    {
      path: '/projectboard-ysc',
      beforeEnter () { location.href = 'https://projectboard.world/ysc' },
      name: 'landingYsc'
    },
    {
      path: '/projectboard-isef',
      beforeEnter () { location.href = 'https://projectboard.world/isef' },
      name: 'landingIsef'
    },
    {
      path: '/makeprojects-edu',
      beforeEnter () { location.href = 'https://makeprojects.com/category/education' },
      name: 'landingEdu'
    },
    {
      path: '/stemevents',
      name: 'landingSteam',
      component: WixUrl
    },
    {
      path: '/schools',
      name: 'landingSchool',
      component: WixUrl
    },
    {
      path: '/engineering-home',
      beforeEnter () { location.href = 'https://new.engineering.com' },
      name: 'landingEngineering'
    },
    {
      path: '/about',
      name: 'landingAbout',
      component: WixUrl
    },
    {
      path: '/engineering-legal',
      beforeEnter () { location.href = 'https://new.engineering.com/legal' },
      name: 'landingLegal'
    },
    {
      path: '/coming-soon',
      name: 'comingSoon',
      component: WixUrl
    },
    {
      path: '/explore/categories/:year',
      name: 'categoryByYear',
      component: CategoryByYear
    },
    {
      path: '/public-exhibition',
      name: 'publicExhibition',
      component: PublicExhibition
    },
    /*
      This should be the last route, routes are matched in order
      This catchall will prevent routing to anything below this point
    */
    {
      path: '*',
      component: WixUrl
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'comingSoon' && Vue.prototype.$isBroadcomMasters) {
    next({ name: 'landingRedirect' })
  }

  if (to.name === 'exploreResources' && !Vue.prototype.$isEngCom) {
    to.matched[0].components.default = NotFound
    return next()
  }
  const requiresAuth = to.matched.some(record => !!record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => !!record.meta.requiresAdmin)
  if (to.query && to.query.utm_source) {
    auth.setUtmSource(to.query.utm_source)
  }

  if (to.query && to.query.rc) {
    auth.setReferralCode(to.query.rc)
  }

  auth.checkLogin().then(() => {
    if (requiresAuth) {
      if (auth.isLoggedIn()) {
        if (!requiresAdmin) {
          return next()
        }
      } else {
        return next({ name: 'home' })
      }
    }

    if (requiresAdmin) {
      if (auth.isAdmin() || auth.isAnalytic() || auth.isCurator() || auth.isResourceEditor()) {
        return next()
      } else {
        // manually set the component to NotFound
        // this way it appears like a normal 404
        // (i.e. path is maintained)
        to.matched[0].components.default = NotFound
        return next()
      }
    }

    return next()
  }, err => console.error(err))
})

router.afterEach((to, from) => {
  socket.log(from.fullPath, to.fullPath)
})

export default router
